<template>
    <b-modal :id="modalId" :title="$t('forms.warning')" size="md" header-bg-variant="danger" header-text-variant="light"
             :cancelTitle="$t('forms.cancel')" :okTitle="$t('forms.delete')" @ok="$emit('confirm')">
        <p class="text-center">{{ $t(messageKey) }}</p>
    </b-modal>
</template>

<script>
export default {
    name: 'ConfirmDeleteModal',
    props: {
        modalId: {
            type: String,
            default: 'confirm-delete'
        },
        extended: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        messageKey() {
            return this.extended ? 'forms.deleteConfirmationMessageExt' : 'forms.deleteConfirmationMessage'
        }
    }
}
</script>
